import { render, staticRenderFns } from "./AttendUser.vue?vue&type=template&id=b664dd2a"
import script from "./AttendUser.vue?vue&type=script&lang=js"
export * from "./AttendUser.vue?vue&type=script&lang=js"
import style0 from "./AttendUser.vue?vue&type=style&index=0&id=b664dd2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports